import { render, staticRenderFns } from "./AlertsComponent.vue?vue&type=template&id=7957d37d&scoped=true"
import script from "./AlertsComponent.js?vue&type=script&lang=js&external"
export * from "./AlertsComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertsComponent.vue?vue&type=style&index=0&id=7957d37d&prod&lang=scss&scoped=true"
import style1 from "./AlertsComponent.vue?vue&type=style&index=1&id=7957d37d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957d37d",
  null
  
)

export default component.exports